import { List, arrayMove } from 'react-movable'

const ReorderItems = ({ items, setItems, type }) => {
  const handleChange = ({ oldIndex, newIndex }) => {
    const newArrayOrder = arrayMove(items, oldIndex, newIndex)
    setItems(newArrayOrder)
  }

  return (
    <List
      lockVertically
      values={items}
      onChange={({ oldIndex, newIndex }) =>
        handleChange({ oldIndex, newIndex })
      }
      renderList={({ children, props, isDragged }) => (
        <div
          {...props}
          style={{ padding: 0, cursor: isDragged ? 'grabbing' : undefined }}
        >
          {children}
        </div>
      )}
      renderItem={({ value, props, isDragged, isSelected }) => (
        <div
          {...props}
          key={props.key}
          className="card px-3 mb-4"
          style={{
            ...props.style,
            cursor: isDragged ? 'grabbing' : 'grab',
            backgroundColor: isDragged || isSelected ? '#EEE' : '#FFF',
          }}
        >
          <div className="card-header border-0 permissions-cardH p-3">
            <div className="d-flex align-content-center align-items-center">
              <div className="flex-grow-0 mr-5">
                <i className="fas fa-arrows-alt fa-2x" />
              </div>
              <div className="flex-grow-1">
                <h3 className="card-title">
                  <i className={`fas fa-box mr-1`}></i>
                  {value.module_info.front_label}
                </h3>
              </div>
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default ReorderItems
